import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faUser, faSearch, faShoppingBag } from '@fortawesome/free-solid-svg-icons';


const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar__top">
        <p>FESTIVE HAMPERS WITH ALL ORDERS ABOVE ₹1890 | FREE SHIPPING</p>
      </div>

      <div className="navbar__main">
      
        <div className="navbar__menu">
          <FontAwesomeIcon icon={faBars} size="lg" />
        </div>

     
        <div className="navbar__brand">
          <h1>RASHKI</h1>
        </div>

      
        <div className="navbar__icons">
          <div className="navbar__location">
            <span>INDIA (INR ₹)</span>
          </div>
          <FontAwesomeIcon icon={faUser} size="lg" />
          <FontAwesomeIcon icon={faSearch} size="lg" />
          <FontAwesomeIcon icon={faShoppingBag} size="lg" />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
